<template>
  <Page title="New Membership Program">
    <Breadcrumbs
      :crumbs="crumbs"
      root-text="Membership Programs"
      class="mb-3"
      @click="handleCrumbClick"
    />
    <MembershipProgramForm />
  </Page>
</template>

<script>
import MembershipProgramForm from "@/MembershipPrograms/MembershipProgramForm.vue";
import Breadcrumbs from "serviceshift-ui/components/General/Breadcrumbs.vue";
import Page from "@/components/Page.vue";
export default {
  components: {
    Page,
    MembershipProgramForm,
    Breadcrumbs
  },
  data() {
    return {
      crumbs: [
        {
          id: "New Membership Program",
          label: "New Membership Program",
        },
      ],
    };
  },
  methods: {
    handleCrumbClick(crumb) {
      if (crumb.id === "root") {
        this.$router.push(this.membershipProgramIndexPath());
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
